// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2.22632 2H22.2263V11H2.22632V2ZM8.22827 5.5H6.22437V7.50391H8.22827V5.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2.22632 13H22.2263V14.5997C21.4762 14.2163 20.6265 14 19.7263 14C16.6888 14 14.2263 16.4624 14.2263 19.5C14.2263 20.4002 14.4426 21.2499 14.826 22H2.22632V13ZM8.22827 16.5H6.22437V18.5039H8.22827V16.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.6622 23.1013L24.3191 17.4445L22.9049 16.0303L18.6622 20.2729L16.5409 18.1516L15.1267 19.5658L18.6622 23.1013Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-data-checked-filled')
export default class DataCheckedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'data-checked-filled',
    }
  }
}
